import CustomEventDispatcher from './CustomEventDispatcher';

class NormalizeOrders extends CustomEventDispatcher {
    constructor() {
        super();
    }

    _normalizeGetOrdersResponse(json) {
        let nJsonOrderResponse = []
        for (let i in json) {
            const order = json[i]
            nJsonOrderResponse.push(this.#normalizeOrder(order))
        }
        return nJsonOrderResponse
    }

    #normalizeOrder(order) {
        let nOrder = {...order}
        if (order?.order_customer?.name) {
            nOrder.customer = order.order_customer.name;
        }
        if (order?.order_customer) {
            delete nOrder.order_customer;
        }
        return nOrder
    }
}

export default NormalizeOrders;
